import { ReactNode } from 'react'
import styles from '../SettingsModal.module.scss'

interface SettingsBlockProps {
  title: string
  children: ReactNode
  /** For a block the modal can be opened on (`useSettingsModal.open`). */
  id?: string
}

/** One part of a section, opened by its heading. */
function SettingsBlock({ title, children, id }: SettingsBlockProps) {
  return (
    <section id={id} className={styles.block}>
      <p className={`title-bold-small ${styles.blockTitle}`}>{title}</p>
      {children}
    </section>
  )
}

export default SettingsBlock
